import {
  InfoCircleOutlined,
  PictureOutlined,
  TagsOutlined,
  UploadOutlined,
} from '@ant-design/icons'
import { Button, Card, Form, Input, Select, Spin, Upload } from 'antd'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import mealApi from '../../api/meal.api'
import ContentHeader from '../../components/shared/ContentHeader'
import styles from '../../styles/product.module.scss'
import '../../styles/program.scss'
import { mealCategory } from './modeal'

const MealRegisterPage = () => {
  const [mealData, setMealData] = useState({
    mealCategoryId: null,
    mealName: '',
    mealImage: null,
  })
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()

  const handleMealDataChange = (key, value) => {
    setMealData((prev) => ({
      ...prev,
      [key]: value,
    }))
  }

  // 이미지 변경 핸들러
  const handleImageChange = (info) => {
    if (info.fileList && info.fileList.length > 0) {
      setMealData((prev) => ({
        ...prev,
        mealImage: info.fileList[0],
      }))
    } else {
      setMealData((prev) => ({
        ...prev,
        mealImage: null,
      }))
    }
  }

  // 필수값 체크 함수
  const isFormValid = () => {
    return mealData.mealCategoryId && mealData.mealName && mealData.mealImage
  }

  const saveMeal = async () => {
    setIsLoading(true)
    try {
      if (!mealData.mealCategoryId || !mealData.mealName) {
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'error',
          title: '카테고리와 음식명을 모두 입력해주세요.',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        })
        return
      }

      const formData = new FormData()

      if (mealData.mealImage?.originFileObj) {
        formData.append('file', mealData.mealImage.originFileObj)
      }

      const params = {
        mealCategoryId: mealData.mealCategoryId,
        mealName: mealData.mealName,
      }

      const res = await mealApi.upsertMeal(params, formData)
      console.log('saveMeal res', res)
      if (res.status === 200) {
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: '음식이 성공적으로 등록되었습니다.',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        })
        navigate('/')
      }
    } catch (error) {
      console.log('saveMeal error', error)
      const errorDescription =
        error.response?.data?.detail?.[0]?.description ||
        '음식 등록 중 오류가 발생했습니다.'
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        title: errorDescription,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      })
      setIsLoading(false)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Spin
      spinning={isLoading}
      size="large"
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1000,
      }}
    >
      <div style={{ width: '100%', paddingBottom: '8rem' }}>
        <ContentHeader title="음식 생성" />
        {/* 밀 타입 */}
        <Card
          title={
            <>
              <TagsOutlined style={{ marginRight: 8 }} />
              음식 카테고리 선택 <span style={{ color: 'red' }}>*</span>
            </>
          }
          style={{ marginBottom: 20 }}
        >
          <Select
            style={{
              width: '25vw',
              minWidth: 200,
              flexShrink: 0,
            }}
            placeholder="식단 카테고리를 선택하세요"
            options={mealCategory.map((item) => ({
              label: item.categoryName,
              value: item.id,
            }))}
            value={mealData.mealCategoryId}
            onChange={(value) => handleMealDataChange('mealCategoryId', value)}
          />
        </Card>

        {/* 음식 정보 */}
        <Card
          title={
            <>
              <InfoCircleOutlined style={{ marginRight: 8 }} />
              음식 정보 <span style={{ color: 'red' }}>*</span>
            </>
          }
          style={{ marginBottom: 20 }}
        >
          <Form.Item
            className={`${['product-register-form-input-wrap']} ${['center-label']}`}
            label="음식명"
            labelAlign="left"
            colon={false}
            labelCol={{
              flex: '0 0 120px',
              style: {
                minWidth: 120,
                whiteSpace: 'nowrap',
                fontWeight: 500,
              },
            }}
            wrapperCol={{ flex: '1 1 auto' }}
            required
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Input
                name="name"
                maxLength={50}
                style={{
                  width: '25vw',
                  minWidth: 200,
                  flexShrink: 0,
                }}
                value={mealData.mealName}
                onChange={(e) =>
                  handleMealDataChange('mealName', e.target.value)
                }
              />
            </div>
            <div className={`${['product-name-count-wrap']}`}>
              <span className={`${['product-name-count']}`}>
                {mealData.mealName.length}
              </span>
              /50
            </div>
          </Form.Item>
        </Card>

        {/* 음식 이미지 첨부 */}
        <Card
          title={
            <>
              <PictureOutlined style={{ marginRight: 8 }} />
              음식 이미지 첨부 <span style={{ color: 'red' }}>*</span>
            </>
          }
          style={{ marginBottom: 20 }}
        >
          <div style={{ width: '25vw', minWidth: 200 }}>
            <Upload
              name="mealImage"
              maxCount={1}
              listType="picture"
              beforeUpload={() => false}
              onChange={handleImageChange}
              fileList={mealData.mealImage ? [mealData.mealImage] : []}
              style={{
                width: '100%',
                minWidth: 200,
              }}
            >
              <Button
                style={{
                  width: '200px',
                  height: '200px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                }}
              >
                <UploadOutlined style={{ fontSize: '24px' }} />
                <span>
                  이미지 선택&nbsp;
                  <p style={{ color: 'gray' }}>(36x36 svg 형식)</p>
                </span>
              </Button>
            </Upload>
          </div>
        </Card>

        {/* 버튼 하단 고정 */}
        <div className={`${styles['product-register-fixed-footer']}`}>
          <Button
            loading={isLoading}
            className={`${styles['product-register-button']} ${styles.save}`}
            disabled={!isFormValid()}
            onClick={saveMeal}
          >
            저장하기
          </Button>
        </div>
      </div>
    </Spin>
  )
}

export default MealRegisterPage
